var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"permission"},[_c('div',{staticClass:"img"},[_c('img',{staticClass:"png",attrs:{"src":_vm.permissionImage}})]),_c('div',{staticClass:"text-center"},[_vm._v("您暂无权限访问，请先联系系统管理员处理！")]),_c('div',{staticClass:"text-bottom"},[_vm._v("-管理员解决完毕后，需要您重新登录门户-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }